import React from 'react';
import { motion } from 'framer-motion';

const InterfaceShowcase: React.FC = () => {
  const showcaseItems = [
    {
      id: 1,
      image: '/colorcopyhex.png',
      alt: 'ColorCache Interface - Copy HEX Values',
      badge: 'Color Copy',
      title: 'One-Click Copy',
      description:
        'Click any color to instantly copy its HEX or RGB values. No more manual typing or searching through brand guides.',
      reverse: false,
    },
    {
      id: 2,
      image: '/dragndrop.png',
      alt: 'ColorCache Interface - Logo Drag and Drop',
      badge: 'Logo Storage',
      title: 'Drag & Drop Brand Logos',
      description:
        'Save brand logos once and drag them directly into your project whenever you need them. No more digging through folders or brand asset docs mid-edit.',
      reverse: true,
    },
    {
      id: 3,
      image: '/fontstorage.png',
      alt: 'ColorCache Interface - Font Notes',
      badge: 'Font Notes',
      title: 'Store Font Notes & Names',
      description:
        'Write down font names, weights, and usage notes right alongside your brand colors so you never have to search through brand guides again.',
      reverse: false,
    },
    {
      id: 4,
      image: '/bulkshare.png',
      alt: 'ColorCache Interface - Export and Share',
      badge: 'Team Sync',
      title: 'Export & Share with Your Team',
      description:
        'Easily export your color collections and brand assets to share with your fellow editors. Keep your entire team consistent across every project.',
      reverse: true,
    },
  ];
    

  return (
    <section className="interface-showcase">
      <div className="container">
        <div className="showcase-grid">
          {showcaseItems.map((item, index) => (
            <motion.div
              key={item.id}
              className={`showcase-item ${item.reverse ? 'reverse' : ''}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 * index, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="showcase-image">
                <img
                  src={item.image}
                  alt={item.alt}
                />
              </div>
              <div className="showcase-content">
                <span className="showcase-badge">{item.badge}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterfaceShowcase;
